<template>
	<v-modal
		name="letbane-tooltip-modal"
		:adaptive="true"
		:max-width="345"
		width="87%"
		height="auto"
		:scrollable="true"
		@closed="closeModal"
	>
		<layout-modal logo-to-show="letbane" @close="closeModal">
			<!-- eslint-disable -->
			<!-- Necessary for v-html because it allows XXS attacks -->
			<div v-if="title" class="title" v-html="title"></div>
			<!-- Necessary for v-html because it allows XXS attacks -->
			<div v-if="text" class="content" v-html="text" />
			<!-- eslint-enable -->
		</layout-modal>
	</v-modal>
</template>

<script>
import LayoutModal from '../layouts/LayoutModal'

export default {
	components: {
		LayoutModal
	},
	props: {
		title: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		}
	},
	methods: {
		closeModal() {
			this.$modal.hide('letbane-tooltip-modal')
			this.$emit('close')
		}
	}
}
</script>

<style scoped>
/* Need to bypass scoped style for this to work when inject raw html */
.title {
	margin-bottom: 1rem;
	font-size: 0.75rem;
	font-weight: 400;
	line-height: 0.9375rem;
	white-space: pre-wrap;
}

.content {
	margin-bottom: 3.4375rem;
	font-size: 0.75rem;
	font-weight: 300;
	line-height: 1.125rem;
	white-space: pre-wrap;
}

.content >>> h1 {
	font-size: 0.75rem;
}

.content >>> p,
.content >>> ul {
	font-weight: 300;
	font-size: 0.75rem;
	line-height: 1.25rem;
}

.content >>> p {
	margin-top: 1rem;
	margin-bottom: 1rem;
}

.content >>> *:first-child {
	margin-top: 0;
}

.content >>> ul {
	padding-left: 0;
	font-weight: 300;
}

.content >>> li {
	list-style: disc inside none;
}

.content >>> a {
	color: #d44428;
	font: 500 16px/1.4 'Comeo', Arial, sans-serif;
	font-size: 0.75rem;
	font-weight: 300;
}
</style>
